import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EditNotificationsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"edit_notifications"}/>
}
